module.exports = __webpack_public_path__ + "static/media/GSF-Kentucky-Derby-6-Gale-and-Bruce.7eeb5108.jpg";